import React from "react";
import Icon from "@mdi/react";
import { mdiArrowDown } from "@mdi/js";
import Text from "../typography/Text";

const File = file => {
  if (!file) return null;
  const [, ext] = file.url.match(/.*\.(.*)/);
  return (
    <div className="file" onClick={() => window.open(file.url, "_blank")}>
      <div className="file_icon">
        <Icon path={mdiArrowDown} size="18px" color="white" />
      </div>
      <div className="file_meta">
        <h5>Download</h5>
        <Text small>
          {ext ? ext.toUpperCase() : ""} /{" "}
          {Math.round(file.filesize / 10240) / 100} Mo
        </Text>
      </div>
    </div>
  );
};

export default File;
